var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isUpdating)?_c('v-progress-circular',{attrs:{"indeterminate":"","size":24}}):_vm._e(),(_vm.resolvedRole !== 'qc' && !_vm.isUpdating)?_c('v-checkbox',{attrs:{"input-value":_vm.value},nativeOn:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.handleChange.apply(null, arguments)}}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }